module.exports = __webpack_public_path__ + "static/slide3.166a84eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hottopics/slide3.png
// module id = 521
// module chunks = 35783957827783